// (function () {
//     'use strict';
//     angular.module('HeroPRO')
//       .service('productFilterService',

export default function ProductFilterService() {
    // var defaultProductFilterLimit = 7;
    this.productTypeFilters = [];
    this.productTypeFiltersClean = [];
    // this.productFilterLimit = defaultProductFilterLimit;

    // this.resetProductFilterLimit = function () {
    //     this.productFilterLimit = defaultProductFilterLimit;
    // };

    this.setupFilterDTOs = function (filters) {
        // add default attribute for showFilter
        for (let i = 0; i < filters.length; i++) {
            filters[i].showFilter = true;
        }
        this.productTypeFilters = angular.copy(filters);
        this.productTypeFiltersClean = angular.copy(filters);
    };

    this.clearFilterDTOs = function () {
        this.productTypeFilters = angular.copy(this.productTypeFiltersClean);
    };

    this.setupFilterOptions = function (filterOptions) {
        // copy the clean filters
        const filters = angular.copy(this.productTypeFiltersClean);
        // build the options per filter type
        for (let i = 0; i < filterOptions.length; i++) {
            const filterOptionSet = filterOptions[i];
            const currentFilters = getFiltersByName(filters, filterOptionSet.Name);

            for (let j = 0; j < currentFilters.length; j++) {
                const currentFilter = currentFilters[j];

                switch (currentFilter.TypeId) {
                // checkbox / options
                case 1:
                case 2:
                    currentFilter.InputOptions = filterOptionSet.Values ? getOptionsList(filterOptionSet.Values, currentFilter.Deprecated_ProductAttributeNameId) : null;
                    break;
                    // min/max
                case 6:
                case 7:
                    currentFilter.InputRangeAttributes = filterOptionSet.Values ? getMinMaxRangeValues(currentFilter, filterOptionSet.Values) : null;
                    break;
                default:
                        // alert("Haven't setup building filter option values for TypeId: " + currentFilter.TypeId);
                }
            }
        }
        // reset the initial filter list
        this.setupFilterDTOs(filters);
    };

    this.getFiltersForDisplay = function () {
        const resultFilters = [];

        for (let i = 0; i < this.productTypeFilters.length; i++) {
            // ignore the max filter
            if (this.productTypeFilters[i].TypeId !== 7) {
                resultFilters.push(this.productTypeFilters[i]);
            }
        }

        return resultFilters;
    };

    this.getFilterByAttributeNameId = function (filters, attributeNameId, searchFilterTypeId) {
        for (let i = 0; i < filters.length; i++) {
            if (filters[i].Deprecated_ProductAttributeNameId === parseInt(attributeNameId)) {
                if (searchFilterTypeId && searchFilterTypeId !== filters[i].SearchFilterTypeId) {
                    continue;
                }

                return filters[i];
            }
        }
    };

    this.getFilterStringsForURL = function () {
        const filterStringsForURL = [];
        const serviceFilters = this.productTypeFilters;

        for (let i = 0; i < serviceFilters.length; i++) {
            const currentFilter = serviceFilters[i];
            let currentFilterString = '';

            if (currentFilter.showFilter === false) {
                continue;
            }

            // If checkboxes
            if (currentFilter.TypeId === 1 && currentFilter.InputOptions) {
                const checkedOptions = [];
                for (let j = 0; j < currentFilter.InputOptions.length; j++) {
                    const currentOption = currentFilter.InputOptions[j];

                    // Add selected options to temp array
                    if (currentOption.isChecked) {
                        checkedOptions.push(currentOption.DisplayName);
                    }
                }

                if (checkedOptions.length > 0) {
                    currentFilterString = `${currentFilter.Deprecated_ProductAttributeNameId}_${checkedOptions.join('~')}`;
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If numeric checkbox list
            if (currentFilter.TypeId === 2) {
                const numericCheckedOptions = [];
                for (let k = 0; k < currentFilter.InputOptions.length; k++) {
                    // TODO was 'var currentOption', might break
                    const optn = currentFilter.InputOptions[k];

                    // Add selected options to temp array
                    if (optn.isChecked) {
                        numericCheckedOptions.push(optn.DisplayName);
                    }
                }
                // add temp array back into filter object
                if (numericCheckedOptions.length > 0) {
                    currentFilterString = `${currentFilter.Deprecated_ProductAttributeNameId}_${numericCheckedOptions.join('~')}`;
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If min/max
            if (currentFilter.TypeId === 6) {
                // If min value set
                if (currentFilter.InputRangeAttributes && currentFilter.InputRangeAttributes.minValue) {
                    currentFilterString = `${currentFilter.Deprecated_ProductAttributeNameId}_${currentFilter.InputRangeAttributes.minValue}_${currentFilter.SearchFilterTypeId}`; // -1 => Min
                    filterStringsForURL.push(currentFilterString);
                }
            }

            if (currentFilter.TypeId === 7) {
                // If max value set
                if (currentFilter.InputRangeAttributes && currentFilter.InputRangeAttributes.maxValue) {
                    currentFilterString = `${currentFilter.Deprecated_ProductAttributeNameId}_${currentFilter.InputRangeAttributes.maxValue}_${currentFilter.SearchFilterTypeId}`; // -2 => Max
                    filterStringsForURL.push(currentFilterString);
                }
            }

            // If descriptive input
            if (currentFilter.TypeId === 4 && currentFilter.userInput) {
                currentFilterString = `${currentFilter.Deprecated_ProductAttributeNameId}_${currentFilter.userInput}`;
                filterStringsForURL.push(currentFilterString);
            }
        }

        return filterStringsForURL;
    };

    this.getFiltersForSearchRequest = function (filterQueryString) {
        // Filter Type Enum
        //    TextSearch = 0
        //    Min = 1
        //    Max = 2
        //

        const filtersForSearch = [];

        let filterPartsFromQueryString = null;

        if (filterQueryString !== undefined && filterQueryString !== '') {
            filterPartsFromQueryString = filterQueryString.split('|');
        }

        if (filterPartsFromQueryString && filterPartsFromQueryString.length > 0) {
            for (let i = 0; i < filterPartsFromQueryString.length; i++) {
                const filterParts = filterPartsFromQueryString[i];
                const parts = filterParts.split('_');
                const productAttributeNameId = parts[0];
                const values = parts[1] ? parts[1].split('~') : null;
                const currentFilter = this.getFilterByAttributeNameId(this.productTypeFilters, productAttributeNameId, parseInt(parts[2]));

                if (currentFilter.TypeId === 1) {
                    // add temp array back into filter object
                    if (values.length > 0) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // TextSearch
                            Values: values,
                        });
                    }
                }

                // If numeric checkbox list
                if (currentFilter.TypeId === 2) {
                    // add temp array back into filter object
                    if (values.length > 0) {
                        for (let valueIndex = 0; valueIndex < values.length; valueIndex++) {
                            let selectedInputOption = null;

                            for (let inputOptionIndex = 0; inputOptionIndex < currentFilter.InputOptions.length; inputOptionIndex++) {
                                if (values[valueIndex] === currentFilter.InputOptions[inputOptionIndex].DisplayName) {
                                    selectedInputOption = currentFilter.InputOptions[inputOptionIndex];
                                }
                            }

                            filtersForSearch.push({
                                FilterName: currentFilter.FilterKey,
                                FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                                FilterType: currentFilter.SearchFilterTypeId,
                                Values: [selectedInputOption.min, selectedInputOption.max],
                            });
                        }
                    }
                }

                if (currentFilter.TypeId === 6 && currentFilter.InputRangeAttributes) {
                    // If min value set
                    if (currentFilter.InputRangeAttributes.minValue) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // Min
                            Values: values,
                        });
                    }
                }

                if (currentFilter.TypeId === 7 && currentFilter.InputRangeAttributes) {
                    // If max value set
                    if (currentFilter.InputRangeAttributes.maxValue) {
                        filtersForSearch.push({
                            FilterName: currentFilter.FilterKey,
                            FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                            FilterType: currentFilter.SearchFilterTypeId, // Max
                            Values: values,
                        });
                    }
                }

                if (currentFilter.TypeId === 4 && currentFilter.userInput) {
                    filtersForSearch.push({
                        FilterName: currentFilter.FilterKey,
                        FilterId: currentFilter.Deprecated_ProductAttributeNameId,
                        FilterType: currentFilter.SearchFilterTypeId, // Text
                        Values: [currentFilter.userInput],
                    });
                }
            }
        }

        return filtersForSearch;
    };

    // specific for min/max filters, min filter is passed into the minmax directive, and the max filter is requested upon initialization
    this.getMaxFilter = function (filterToMatch) {
        let filter = null;

        // looping through filters looking for filtertypeid = 7 (max), that matches the display name (Maybe could match an id?)

        for (let i = 0; i < this.productTypeFilters.length; i++) {
            if (this.productTypeFilters[i].TypeId === 7 && this.productTypeFilters[i].DisplayName === filterToMatch.DisplayName) {
                filter = this.productTypeFilters[i];
                break;
            }
        }

        return filter;
    };

    function getFiltersByName(filters, name) {
        const foundFilters = [];

        for (let i = 0; i < filters.length; i++) {
            if (filters[i].FilterKey.toLowerCase() === name.toLowerCase()) {
                foundFilters.push(filters[i]);
            }
        }

        return foundFilters;
    }

    function getOptionsList(values, productAttributeNameId) {
        const options = [];

        // optn.optionID = vm.currentFilter.ProductAttributeNameId + "-" + options;
        // optn.isChecked = false;
        // optn.letter = optn.DisplayName.charAt(0);

        for (let i = 0; i < values.length; i++) {
            options.push({
                DisplayName: values[i].Value,
                isChecked: false,
                letter: values[i].Value.charAt(0),
                optionID: `${productAttributeNameId}-${i}`,
                count: values[i].Count,
            });
        }

        return options;
    }

    function getMinMaxRangeValues(filter, values) {
        let min = null;
        let max = null;

        for (let i = 0; i < values.length; i++) {
            const value = parseFloat(values[i].Value);

            if (i === 0) {
                min = value;
                max = value;
                continue;
            }

            min = min > value ? value : min;
            max = max < value ? value : max;
        }

        return {
            Min: min,
            Max: max,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/productCenter/services/productFilterService.js